export default "__VITE_ASSET__sKcb0rVi__"